module.exports = __webpack_public_path__ + "img/trip_sendai23.fb91cd75.jpg";